import React from 'react';
import { Switch } from 'react-router-dom';

import Route from './Route';

import Home from '~/pages/Home';
import Dashboard from '~/pages/Dashboard';
import Events from '~/pages/Events';
import NewEvent from '~/pages/Events/NewEvent';
import UpdateEvent from '~/pages/Events/UpdateEvent';
import Clients from '~/pages/Clients';
import Vouchers from '~/pages/Vouchers';
import Financial from '~/pages/Financial';
import Help from '~/pages/Help';
import Configurations from '~/pages/Configurations';
import Login from '~/pages/Login';
import UserList from '~/pages/Listings/Users';
import EventsList from '~/pages/Listings/Events';
import PaymentsList from '~/pages/Listings/Payments';
import TicketsList from '~/pages/Listings/Tickets';
import ForgotPassword from '~/pages/ForgotPassword';
import Withdrawal from '~/pages/Listings/Withdrawal';
import Documents from '~/pages/Documents';
import ChangePassword from '~/pages/ChangePassword';
import Organizers from '~/pages/Organizers';
import NewOrganizer from '~/pages/Organizers/NewOrganizer';
import UpdateOrganizer from '~/pages/Organizers/UpdateOrganizer';
import Contracts from '~/pages/Contracts';
import Gateways from '~/pages/Gateways';
import Cancels from '~/pages/Cancels';
import BulkEmails from '~/pages/BulkEmails';
import Performance from '~/pages/Performance';
import AiAgents from '~/pages/AiAgents';

const routes: React.FC = () => {
  return (
    <Switch>
      <Route path={`${process.env.PUBLIC_URL}/`} exact component={Login} />
      <Route
        path={`${process.env.PUBLIC_URL}/recuperar-senha`}
        exact
        component={ForgotPassword}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/alterar-senha/:token`}
        exact
        component={ChangePassword}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/inicio`}
        exact
        component={Home}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/dashboard`}
        exact
        component={Dashboard}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/eventos`}
        exact
        component={Events}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/eventos/novo-evento`}
        exact
        component={NewEvent}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/eventos/editar-evento/:slug`}
        exact
        component={UpdateEvent}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/eventos/:slug/resumo`}
        exact
        component={UpdateEvent}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/clientes`}
        exact
        component={Clients}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/cupons`}
        exact
        component={Vouchers}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/financeiro`}
        exact
        component={Financial}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/reclamacoes`}
        exact
        isPrivate
        component={Help}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/documentos`}
        exact
        isPrivate
        component={Documents}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/listagens/usuarios`}
        exact
        component={UserList}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/listagens/eventos`}
        exact
        component={EventsList}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/listagens/pedidos`}
        exact
        component={PaymentsList}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/listagens/inscricoes`}
        exact
        component={TicketsList}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/solicitacao-de-saque`}
        exact
        component={Withdrawal}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/configuracao`}
        exact
        component={Configurations}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/organizadores`}
        exact
        component={Organizers}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/organizadores/novo-organizador`}
        exact
        component={NewOrganizer}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/organizadores/editar-organizador/:organizer_id`}
        exact
        component={UpdateOrganizer}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/contratos`}
        exact
        component={Contracts}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/gateways`}
        exact
        component={Gateways}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/cancelamentos`}
        exact
        component={Cancels}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/disparo-emails`}
        exact
        component={BulkEmails}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/performance`}
        exact
        component={Performance}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/agentes-ia`}
        exact
        component={AiAgents}
        isPrivate
      />
    </Switch>
  );
};

export default routes;
